import React, { Fragment } from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import messages from './messages'
import s from './FooterCopyright.scss'


const year = new Date().getFullYear()

const FooterCopyright = () => (
  <Fragment>
    <FormattedHTMLMessage className={s.madeWith} tag="div" {...messages.madeWith} />
    <FormattedMessage className={s.copyright} tag="div" {...messages.copyrights} values={{ year }} />
  </Fragment>
)


export default FooterCopyright
